module.exports = __webpack_public_path__ + "static/img/logole1.f0fa6ad6.png";